import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import authReducer from '@features/current-user/login/model/slice';
import currentUserReducer from '@entities/current-user/model/slice';
import { authApi } from '@shared/api/base/auth-base';
import { currentUserApi } from '@entities/current-user/api/base';
import feedbackReducer from '@entities/feedback/model/slice';
import elementsReducer from '@shared/store/model/slice';
import { userApi } from '@entities/user/api/user-management-api';
import { fileApi } from '@entities/file/api/file-api';
import { organizationBaseApi } from '@entities/organization/api/base';
import { orderBaseApi } from '@entities/order/api/base';
import { requestBaseApi } from '@entities/request/api/base';
import { feedbackBaseApi } from '@entities/feedback/api/base';
import { productBaseApi } from '@entities/product/api/base';
import { catalogBaseApi } from '@entities/catalog/api/base';
import { feedbackRequestBaseApi } from '@entities/feedback-request/api/base';
import { feedbackSubjectBaseApi } from '@entities/feedback-subject/api/base';
import { inputFileSearchBaseApi } from '@shared/ui/input-file-search/api/base';
import { userProfileOptionBaseApi } from '@entities/user-profile-option/api/base';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        currentUser: currentUserReducer,
        feedback: feedbackReducer,
        elements: elementsReducer,
        [organizationBaseApi.reducerPath]: organizationBaseApi.reducer,
        [catalogBaseApi.reducerPath]: catalogBaseApi.reducer,
        [feedbackRequestBaseApi.reducerPath]: feedbackRequestBaseApi.reducer,
        [feedbackSubjectBaseApi.reducerPath]: feedbackSubjectBaseApi.reducer,
        [inputFileSearchBaseApi.reducerPath]: inputFileSearchBaseApi.reducer,
        [authApi.reducerPath]: authApi.reducer,
        [currentUserApi.reducerPath]: currentUserApi.reducer,
        [userApi.reducerPath]: userApi.reducer,
        [fileApi.reducerPath]: fileApi.reducer,
        [feedbackBaseApi.reducerPath]: feedbackBaseApi.reducer,
        [orderBaseApi.reducerPath]: orderBaseApi.reducer,
        [requestBaseApi.reducerPath]: requestBaseApi.reducer,
        [productBaseApi.reducerPath]: productBaseApi.reducer,
        [userProfileOptionBaseApi.reducerPath]: userProfileOptionBaseApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ serializableCheck: false })
            .concat(organizationBaseApi.middleware)
            .concat(catalogBaseApi.middleware)
            .concat(feedbackRequestBaseApi.middleware)
            .concat(inputFileSearchBaseApi.middleware)
            .concat(feedbackSubjectBaseApi.middleware)
            .concat(authApi.middleware)
            .concat(currentUserApi.middleware)
            .concat(orderBaseApi.middleware)
            .concat(feedbackBaseApi.middleware)
            .concat(requestBaseApi.middleware)
            .concat(userApi.middleware)
            .concat(fileApi.middleware)
            .concat(productBaseApi.middleware)
            .concat(userProfileOptionBaseApi.middleware),
});

setupListeners(store.dispatch);

export default store;
